"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.labelStyles = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Error = _interopRequireDefault(require("../Error"));

var _Constant = require("../../Constant");

var _VisuallyHidden = _interopRequireDefault(require("../../VisuallyHidden"));

var _Text = require("../../Text");

var _Typography = require("../../Typography");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n\n  > .error {\n    color: ", ";\n    display: inline;\n    margin-bottom: 0;\n    margin-left: 4px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var labelStyles = "\n  max-width: 100%;\n";
exports.labelStyles = labelStyles;

var Element = _styledComponents.default.label.attrs(function (_ref) {
  var errorText = _ref.errorText,
      value = _ref.value;
  return {
    'data-has-value': !!value || typeof value === 'number',
    'data-error': errorText && errorText.length > 0
  };
})(_templateObject(), labelStyles, _Constant.Color.ERROR);

var Label = function Label(_ref2) {
  var children = _ref2.children,
      errorText = _ref2.errorText,
      isVisuallyHidden = _ref2.isVisuallyHidden,
      asterisks = _ref2.asterisks,
      props = (0, _objectWithoutProperties2.default)(_ref2, ["children", "errorText", "isVisuallyHidden", "asterisks"]);
  var labelText = isVisuallyHidden ? /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, null, children) : /*#__PURE__*/_react.default.createElement(_Typography.Typography.SmallBodyBold, {
    as: "span"
  }, children);
  return children ? /*#__PURE__*/_react.default.createElement(Element, props, labelText, asterisks && /*#__PURE__*/_react.default.createElement(_Text.Asterisk, {
    asterisks: asterisks
  }), /*#__PURE__*/_react.default.createElement(_Error.default, null, errorText)) : null;
};

Label.propTypes = {
  /** The number of asterisks to render */
  asterisks: _propTypes.default.number,

  /** The node that should be rendered */
  children: _propTypes.default.node.isRequired,

  /** applied to the base element */
  className: _propTypes.default.string,

  /** The text of an error within a form */
  errorText: _propTypes.default.string,

  /** Ideally, label text is always visible.
   * If necessary, this prop will hide label text from sighted users while still making it available to assistive technology.
   * It will not hide error text.
   */
  isVisuallyHidden: _propTypes.default.bool
};
Label.defaultProps = {
  asterisks: null,
  className: null,
  errorText: '',
  isVisuallyHidden: false
};
var _default = Label;
exports.default = _default;